import * as ActionTypes from './ActionTypes';



export const setOnlineStatus = (onlineUserId) => ({ type: ActionTypes.SET_ONLINE_STATUS, payload: onlineUserId });
export const setOfflineStatus = (offlineUserId) => ({ type: ActionTypes.SET_OFFLINE_STATUS, payload: offlineUserId });
